import { render, staticRenderFns } from "./ScreenDetails.vue?vue&type=template&id=035e51bc"
import script from "./ScreenDetails.vue?vue&type=script&lang=js"
export * from "./ScreenDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports